import $ from "jquery";
import {$body} from '../Constants';
import HtmlElement from './HtmlElement';

/**
 * NavLanguage
 */
const NavLanguage = (() => {
  /**
   * Selector
   */
  const Selector = {
    NAV_LANGUAGE: '.menu-language'
  };


  /**
   * NavLanguage
   *
   * @class
   * @augments HtmlElement
   */
  class NavLanguage extends HtmlElement {
    // Public

    /**
     * Handles ready event
     *
     * @return void
     */
    onReady() {
      super.onReady();

      this.$element.find('.sub').each((i, el) => {
        const $a = $(el).find('> a');
        const $level2 = $(el).find('.level-2');

        $a.on('click', () => {
          $level2.slideToggle();
        });
      });
    }
  }

  return NavLanguage._getElement($body.find(Selector.NAV_LANGUAGE), NavLanguage);
})();

export default NavLanguage;
